import { SidebarMenuItem } from './SidebarMenuItem';
import icDashboard from '../../assets/icons/icons_navigation_24_home.svg';
import i18n from '../../utils/i18n';
import icRepayment from '../../assets/icons/icons_payments_24_send_money.svg';
import icPreviousLoan from '../../assets/icons/icons_navigation_24_history.svg';
import { isRoleBorrowerAgent, isRoleFinanceAgent, isRoleOpsAgent } from '../../constants/roles';
import { ISidebarMenu } from '../../hooks/SidebarMenuHook';
import { SettlementFinanceRoutes } from '../../constants/routes';

const sideMenuItemsForBorrowerAgent = [
  new SidebarMenuItem(icDashboard, i18n.t('sidebar.createSubmission'), SettlementFinanceRoutes.createSubmission),
  new SidebarMenuItem(icRepayment, i18n.t('sidebar.submitRepayment'), SettlementFinanceRoutes.submitRepayment),
  new SidebarMenuItem(icPreviousLoan, i18n.t('sidebar.history'), SettlementFinanceRoutes.disbursementHistory),
];

const sideMenuItemsForFinanceAdmin = [
  new SidebarMenuItem(icRepayment, i18n.t('sidebar.confirmRepayment'), SettlementFinanceRoutes.confirmRepayment),
  new SidebarMenuItem(icPreviousLoan, i18n.t('sidebar.history'), SettlementFinanceRoutes.disbursementHistory),
];

const sideMenuItemsForCreditRiskOps = [
  new SidebarMenuItem(icDashboard, i18n.t('sidebar.viewDisbursement'), SettlementFinanceRoutes.pendingDisbursement),
];

const settlementFinanceSidebarMenu = function getMenu(roles?: string[]): ISidebarMenu {
  let combinedMenu:SidebarMenuItem[] = [];
  if (isRoleBorrowerAgent(roles)) {
    combinedMenu = combinedMenu.concat(sideMenuItemsForBorrowerAgent);
  }
  if (isRoleFinanceAgent(roles)) {
    combinedMenu = combinedMenu.concat(sideMenuItemsForFinanceAdmin);
  }
  if (isRoleOpsAgent(roles)) {
    combinedMenu = combinedMenu.concat(sideMenuItemsForCreditRiskOps);
  }
  const distinctMenu = combinedMenu.filter(
    (item, index) => index === combinedMenu.findIndex(
      (menuItem) => menuItem.route === item.route,
    ),
  );
  return {
    filteredMenu: distinctMenu,
    borrowerAgentMenuList: sideMenuItemsForBorrowerAgent,
    financeAdminMenuList: sideMenuItemsForFinanceAdmin,
    creditOpsMenuList: sideMenuItemsForCreditRiskOps,
  };
};

export default settlementFinanceSidebarMenu;
